package app

import kotlinx.browser.localStorage
import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

private const val AreasKey = "blurAreas"
private const val IntensityKey = "blurIntensity"

private val storageJson = Json {
    ignoreUnknownKeys = true
    encodeDefaults = true
}

@Serializable
data class StoredState(
    val areas: List<BlurArea> = emptyList(),
    val blurIntensity: Int = 10
)

fun loadStoredState(): StoredState {
    return try {
        val areas = localStorage.getItem(AreasKey)
            ?.let { storageJson.decodeFromString<List<BlurArea>>(it) }
            .orEmpty()
        val intensity = localStorage.getItem(IntensityKey)?.toIntOrNull() ?: 10
        StoredState(areas = areas, blurIntensity = intensity.coerceIn(1, 20))
    } catch (_: Throwable) {
        StoredState()
    }
}

fun saveStoredState(areas: List<BlurArea>, blurIntensity: Int) {
    localStorage.setItem(AreasKey, storageJson.encodeToString(areas))
    localStorage.setItem(IntensityKey, blurIntensity.coerceIn(1, 20).toString())
}
